<template>
  <BlocoFormularioCadastro @salvar="submit()">
    <template #form>
      <div class="row">
        <div class="col-xs-12">
          <div
            :class="{ 'has-error': v$.senhaAtual.$error }"
            class="form-group"
            style="max-width: 300px; margin: 1rem auto"
          >
            <label for="senhaAtual"> Senha atual </label>
            <input
              id="senhaAtual"
              v-model="senhaAtual"
              data-test-id="input-senhaatual"
              type="password"
              class="form-control"
              placeholder="Senha atual do usuário"
              @input="v$.senhaAtual.$touch()"
            />
            <span v-if="v$.senhaAtual.$dirty">
              <span v-if="!v$.senhaAtual.required" class="help-block">
                Informa a senha atual.
              </span>
            </span>
          </div>
        </div>
        <div class="col-xs-12">
          <div
            :class="{
              'has-error': v$.novaSenha.$error,
            }"
            class="form-group"
            style="max-width: 300px; margin: 1rem auto"
          >
            <label for="novaSenha"> Nova senha </label>
            <input
              id="novaSenha"
              v-model="novaSenha"
              data-test-id="input-novasenha"
              type="password"
              class="form-control"
              placeholder="Nova senha"
              @input="v$.novaSenha.$touch()"
            />
            <span v-if="v$.novaSenha.$dirty">
              <span v-if="!v$.novaSenha.required" class="help-block">
                Campo é obrigatório.
              </span>
            </span>
          </div>
        </div>
        <div class="col-xs-12">
          <div
            :class="{
              'has-error': v$.novaSenhaConfirmacao.$error,
            }"
            class="form-group"
            style="max-width: 300px; margin: 1rem auto"
          >
            <label for="novaSenhaConfirmacao"> Confirme a nova senha </label>
            <input
              id="novaSenhaConfirmacao"
              v-model="novaSenhaConfirmacao"
              data-test-id="input-novasenhaconfirmacao"
              type="password"
              class="form-control"
              placeholder="Repita a nova senha"
              @input="v$.novaSenhaConfirmacao.$touch()"
            />
            <span v-if="v$.novaSenhaConfirmacao.$dirty">
              <span v-if="!v$.novaSenhaConfirmacao.required" class="help-block">
                Campo é obrigatório.
              </span>
            </span>
          </div>
        </div>
      </div>
      <ul class="row" style="max-width: 300px; margin: 1rem auto">
        <li :class="senhaNovaConfere ? 'valido' : 'invalido'"
          >As senhas conferem</li
        >
        <li :class="!mesmaDaAntiga ? 'valido' : 'invalido'"
          >Nova senha deve ser diferente da atual</li
        >
        <li :class="tamanhoValido ? 'valido' : 'invalido'"
          >Com pelo menos 6 caracteres</li
        >
        <li :class="temNumeros ? 'valido' : 'invalido'"
          >Com pelo menos um número (0-9)</li
        >
        <li :class="temLetras ? 'valido' : 'invalido'"
          >Com pelo menos uma letra minúscula e maiúscula (A-z)</li
        >
        <li :class="temCaracteresEspeciais ? 'valido' : 'invalido'"
          >Com pelo menos uma um símbolo (@, $, #, _ ou &)</li
        >
      </ul>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import Autenticacao from '@/servicos/Autenticacao'
import DialogoServico from '@/servicos/DialogoServico'
import UsuarioServico from '@/servicos/UsuarioServico'

const autenticacao = new Autenticacao()
const usuarioServico = new UsuarioServico()
const dialogoServico = new DialogoServico()

export default {
  components: { BlocoFormularioCadastro },

  setup() {
    useMenu(59)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      senhaAtual: '',
      novaSenha: '',
      novaSenhaConfirmacao: '',
    }
  },
  computed: {
    mesmaDaAntiga() {
      return this.senhaAtual === this.novaSenha
    },
    senhaNovaConfere() {
      return this.novaSenha && this.novaSenha === this.novaSenhaConfirmacao
    },
    tamanhoValido() {
      return this.novaSenha.length >= 6
    },
    temNumeros() {
      return /\d/g.test(this.novaSenha)
    },
    temLetras() {
      return /([A-Z])/g.test(this.novaSenha) && /([a-z])/g.test(this.novaSenha)
    },
    temCaracteresEspeciais() {
      return /\W|_/g.test(this.novaSenha)
    },
  },
  methods: {
    submit() {
      if (
        this.mesmaDaAntiga ||
        !this.senhaNovaConfere ||
        !this.tamanhoValido ||
        !this.temLetras ||
        !this.temNumeros ||
        !this.temCaracteresEspeciais
      ) {
        dialogoServico.alerta({
          title: 'Erro',
          content: 'Informe os campos corretamente.',
        })
        return
      }

      let id = this.$route.params.id

      // Se usuário não informado na rota usa o usuário logado
      if (!id) {
        const usuarioLoagdo = autenticacao.getUsuario()
        id = usuarioLoagdo._id
      }

      usuarioServico
        .trocarSenha({
          id,
          senhaAtual: this.senhaAtual,
          novaSenha: this.novaSenha,
        })
        .then((result) => {
          if (!result.erro) {
            dialogoServico.alerta({
              content: 'Senha alterada com sucesso.',
            })
          }
        })
        .catch((err) => {
          dialogoServico.alerta({
            title: 'Erro',
            content: 'Ocorreu um erro ao tentar atualizar a senha.',
          })
          console.error(err)
        })
    },
  },
  validations: {
    senhaAtual: { required },
    novaSenha: { required },
    novaSenhaConfirmacao: {
      required,
      sameAsNovaSenha(value) {
        return value === this.novaSenha
      },
    },
  },
}
</script>

<style scoped>
.valido {
  color: #18bc9c;
}

.invalido {
  color: #e74c3c;
}
</style>
